import toast from "react-hot-toast";

export function retainKeys(obj, keysToKeep) {
    const result = {};

    for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
            result[key] = {};

            for (const subKey in obj[key]) {
                if (obj[key].hasOwnProperty(subKey)) {
                    if (subKey === 'attribute_id' && keysToKeep.includes(subKey)) {
                        result[key]['option_id'] = obj[key][subKey];
                    } else if (keysToKeep.includes(subKey)) {
                        result[key]['option_value'] = Number(obj[key][subKey]);
                    }
                }
            }
        }
    }

    return result;
}

export function checkRequiredSegments(bundles, selectedProducts){
    let satisfies = true
    const selectedSKUs = selectedProducts.map(sp => sp.sku)

    for (let bundle of bundles) {
        console.log("bundle", bundle?.product_links.map(p => p.sku)?.some(sp => selectedSKUs.includes(sp)))
        //  bundle?.required != 1
        if ((bundle?.product_links.map(p => p.sku)?.some(sp => selectedSKUs.includes(sp)) && selectedSKUs?.length > 0 )|| bundle.required != 1 ) {
            satisfies = true
        }else{
            satisfies = false
            toast.error("Please choose at least one product from " + bundle?.title)
            break;
        }
    }
    return satisfies
}